export default __webpack_public_path__ + "static/media/news37.6c09f0c7.jpg";